"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scene3DRotationInfo = void 0;
var math_1 = require("@devexpress/utils/lib/utils/math");
var Scene3DRotationInfo = (function () {
    function Scene3DRotationInfo(latitude, longitude, revolution) {
        if (latitude === void 0) { latitude = 0; }
        if (longitude === void 0) { longitude = 0; }
        if (revolution === void 0) { revolution = 0; }
        this.latitude = latitude;
        this.longitude = longitude;
        this.revolution = revolution;
    }
    Scene3DRotationInfo.prototype.calculateHash = function () {
        return math_1.MathUtils.somePrimes[0] * this.latitude ^
            math_1.MathUtils.somePrimes[1] * this.longitude ^
            math_1.MathUtils.somePrimes[2] * this.revolution;
    };
    Scene3DRotationInfo.prototype.getHashCode = function () {
        return this.hash === undefined ? this.hash = this.calculateHash() : this.hash;
    };
    Scene3DRotationInfo.prototype.equals = function (obj) {
        return obj &&
            this.latitude == obj.latitude &&
            this.longitude == obj.longitude &&
            this.revolution == obj.revolution;
    };
    Scene3DRotationInfo.prototype.clone = function () {
        var obj = new Scene3DRotationInfo();
        obj.latitude = this.latitude;
        obj.longitude = this.longitude;
        obj.revolution = this.revolution;
        return obj;
    };
    Scene3DRotationInfo.defaultInfo = new Scene3DRotationInfo();
    return Scene3DRotationInfo;
}());
exports.Scene3DRotationInfo = Scene3DRotationInfo;
